export default {
  XB: {type: 'syrk_xb', name: '性别'},
  MZ: {type: 'syrk_mz', name: '民族'},
  XL: {type: 'syrk_whcd', name: '学历'},
  RYLB: {type: 'syrk_rylb', name: '人员类别'},
  DSR_RYLB: {type: 'dsr_rylb', name: '当事人-人员类别'},

  ZYLB: {type: 'syrk_zylb', name: '职业类别'},
}
